import { AuthAxiosService } from "../axiosClient";
import IUser from "./IUser";
import { IAuthRequest, IRegisterUserRequest } from "./AuthRequest";
import { IAuthResponse } from "./IAuthResponse";
import HTTPStatus from "../../utils/HTTPStatus";
import IUserProfile from "./IUserProfile";
import IEditUserModel from "./IEditUserModel";
import IResetPassword from "./IResetPassword";
import { IAuthPhotoResponse } from "./IAuthPhotoResponse";
import { AxiosRequestConfig } from "axios";
import {
  IForgotPassword,
  IResetPasswordWithToken,
} from "./IForgotPassword";

class AuthenticationService extends AuthAxiosService {
  public async login(
    authRequest: IAuthRequest
  ): Promise<{ data: IAuthResponse }> {
    const response = await this.post<IAuthRequest, { data: IAuthResponse }>(
      "/auth/login",
      {
        ...authRequest,
      }
    );
    return response.data;
  }

  public async registerUser(
    registrationData: IRegisterUserRequest
  ): Promise<HTTPStatus> {
    const response = await this.post<IRegisterUserRequest, HTTPStatus>(
      "/auth/register",
      registrationData
    );

    return response.status;
  }

  public async me(config?: AxiosRequestConfig): Promise<{ data: IUser }> {
    const response = await this.getAuth<void, { data: IUser }>("/auth/me", config);
    return response.data;
  }

  public async profile(): Promise<{ data: IUserProfile }> {
    const response = await this.getAuth<void, { data: IUserProfile }>(
      "/auth/profile"
    );
    return response.data;
  }

  public async refresh(): Promise<HTTPStatus> {
    const response = await this.post<void, HTTPStatus>(
      "/auth/refresh"
    );
    return response.status;
  }

  public async uploadProfilePhoto(data: FormData): Promise<{data: IAuthPhotoResponse}> {
    const response = await this.postAuth<FormData, {data: IAuthPhotoResponse}>(
      "/auth/profile/photo",
      data
    );

    return response.data;
  }

  public async logout(): Promise<HTTPStatus> {
    const response = await this.postAuth<void, HTTPStatus>("/auth/logout");
    return response.status;
  }

  public async logoutAll(): Promise<HTTPStatus> {
    const response = await this.postAuth<void, HTTPStatus>("/auth/logout-all");
    return response.status;
  }

  public async updateProfileData(
    userData: IEditUserModel
  ): Promise<{ data: IAuthResponse }> {
    const response = await this.putAuth<
      IEditUserModel,
      { data: IAuthResponse }
    >(`/auth/profile`, userData);
    return response.data;
  }

  public async resetPassword(passwordData: IResetPassword): Promise<void> {
    const response = await this.putAuth<IResetPassword>(
      `/auth/password`,
      passwordData
    );
    return response.data;
  }

  public async forgotPassword(payload: IForgotPassword): Promise<HTTPStatus> {
    // Public endpoint. The backend always returns 200 to avoid leaking
    // whether the email is registered, so we map success purely to a
    // 2xx status — never to "if it really sent the email".
    const response = await this.post<IForgotPassword, HTTPStatus>(
      "/auth/password/forgot",
      payload
    );
    return response.status;
  }

  public async resetPasswordWithToken(
    payload: IResetPasswordWithToken
  ): Promise<HTTPStatus> {
    const response = await this.post<IResetPasswordWithToken, HTTPStatus>(
      "/auth/password/reset",
      payload
    );
    return response.status;
  }
}
const authServiceInstance = new AuthenticationService();
export default authServiceInstance;
